import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/landing-pages', { params })
    return response.data?.data || null
  },
  async getDetail(params){
    let response = await api.get('/admin/landing-pages/detail', { params })
    return response.data?.data?.document || null
  },
  async create(payload) {
    const response = await api.post('/admin/landing-pages', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/landing-pages', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/landing-pages', {
      data: payload,
    })
    return response
  },
}
